function threeDigits(money: number): string {
  if (Number.isNaN(Number(money))) {
    return '';
  }
  return (money || money === 0) ? money.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : money.toString();
}

export default threeDigits;
